import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

const NotaCreditoVentaAltaRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();
  const target = query ? `/ventas/notas-credito/nuevo-pos?${query}` : '/ventas/notas-credito/nuevo-pos';

  return <Navigate replace to={target} />;
};

export default NotaCreditoVentaAltaRedirect;
